import React from 'react';
import cx from 'classnames';

import { withStyles, Theme, WithStyles, createStyles } from '@material-ui/core';

import { TextField, TextFieldProps, units } from '@ha/dsl';

export const styles = (theme: Theme) =>
  createStyles({
    textField: {
      borderRadius: '4px',
    },
    input: {
      color: theme.palette.grey[700],
      textIndent: units.rem(1),
      fontSize: units.rem(1.25),
      lineHeight: 'normal',
    },
    root: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: '#F1F2F6',
      height: units.rem(3.5),
      borderRadius: units.rem(0.25),
      '&:before': {
        borderBottomColor: 'transparent',
      },
      '&:hover:before': {
        borderBottomColor: `${theme.palette.primary.light} !important`,
      },
    },
  });

export const SearchBarTextField: React.FC<
  TextFieldProps & WithStyles<typeof styles>
> = ({
  classes,
  className,

  InputProps = {},
  ...rest
}) => (
  <TextField
    className={cx(classes.textField, className)}
    InputProps={{
      ...InputProps,
      classes: {
        ...InputProps.classes,
        root: cx(classes.root, InputProps.classes && InputProps.classes.root),
        input: cx(
          classes.input,
          InputProps.classes && InputProps.classes.input,
        ),
      },
    }}
    {...rest}
  />
);

export default withStyles(styles)(
  SearchBarTextField,
) as React.ComponentClass<TextFieldProps>;
